export interface KV {
	/**
	 * Returns if key exists
	 *
	 * @param {string} key - Lookup Key
	 *
	 */
	has(key: string): boolean;

	/**
	 * Returns a the stored value if exist or null if it doesn't
	 *
	 * @param {string} key - Lookup Key
	 * @param {any=} defaultValue - Value that return if the key doesn't exist
	 *
	 */
	get(key: string, defaultValue?: any): any | null;

	/**
	 * Set a key to hold a value, if the key already had a value it is
	 * overwritten, regardless of its type. It has an optional ttl, if it's
	 * set as `null` the key wont die. If is not set is going to use a default
	 * value of `10 minutes`.
	 *
	 * @param {string} key - Lookup Key
	 * @param {any} data - Data that want to be stored.
	 * @param {number=} ttl - Time-to-live in minutes
	 *
	 */
	set(key: string, data: any, ttl?: number | null): void;

	/**
	 * Remove a value based on it's key
	 *
	 * @param {string} key - Lookup Key
	 *
	 */
	delete(key: string): void;
	/**
	 * Clear the entire Key-Value Store
	 *
	 */
	clear(): void;
}

export interface AsyncKV {
	/**
	 * Load data
	 *
	 *
	 */
	load(): Promise<void>;

	/**
	 * Returns if key exists
	 *
	 * @param {string} key - Lookup Key
	 *
	 */
	has(key: string): Promise<boolean>;

	/**
	 * Returns a the stored value if exist or null if it doesn't
	 *
	 * @param {string} key - Lookup Key
	 * @param {any=} defaultValue - Value that return if the key doesn't exist
	 *
	 */
	get(key: string, defaultValue?: any): Promise<any | null>;

	/**
	 * Set a key to hold a value, if the key already had a value it is
	 * overwritten, regardless of its type. It has an optional ttl, if it's
	 * set as `null` the key wont die. If is not set is going to use a default
	 * value of `10 minutes`.
	 *
	 * @param {string} key - Lookup Key
	 * @param {any} data - Data that want to be stored.
	 * @param {number=} ttl - Time-to-live in minutes
	 *
	 */
	set(key: string, data: any, ttl?: number | null): Promise<void>;

	/**
	 * Remove a value based on it's key
	 *
	 * @param {string} key - Lookup Key
	 *
	 */
	delete(key: string): Promise<void>;
	/**
	 * Clear the entire Key-Value Store
	 *
	 */
	clear(): Promise<void>;
}

export function minutesToMillis(min: number) {
	return min * 60000;
}

export interface Entries {
	[key: string]: Entry;
}

export interface Entry {
	value: any;
	ttl: Date | null;
}
